export type DiscordBaseTheme = "light" | "ash" | "dark" | "onyx";

export type DiscordPalette = {
  base: string;
  sidebar: string;
  primary: string;
  elevated: string;
  input: string;
  text: string;
  muted: string;
  accent: string;
  mention: string;
};

const COMMON = {
  accent: "#5865f2",
  mention: "#f0b232",
} as const;

const DISCORD_PALETTES: Record<DiscordBaseTheme, DiscordPalette> = {
  light: {
    base: "#e3e5e8",
    sidebar: "#f2f3f5",
    primary: "#ffffff",
    elevated: "#e9eaec",
    input: "#ebedef",
    text: "#1e1f22",
    muted: "#5c5e66",
    ...COMMON,
  },
  ash: {
    base: "#1e1f22",
    sidebar: "#2b2d31",
    primary: "#313338",
    elevated: "#383a40",
    input: "#1e1f22",
    text: "#f2f3f5",
    muted: "#b5bac1",
    ...COMMON,
  },
  dark: {
    base: "#0e0f11",
    sidebar: "#111214",
    primary: "#18191d",
    elevated: "#232428",
    input: "#202225",
    text: "#f2f3f5",
    muted: "#949ba4",
    ...COMMON,
  },
  onyx: {
    base: "#070709",
    sidebar: "#0c0d0f",
    primary: "#111214",
    elevated: "#18191d",
    input: "#1b1d22",
    text: "#f2f3f5",
    muted: "#b5bac1",
    ...COMMON,
  },
};

export function getDiscordPalette(theme: DiscordBaseTheme): DiscordPalette {
  return DISCORD_PALETTES[theme];
}
